import { render, staticRenderFns } from "./ValidationObserver.vue?vue&type=template&id=281b8378&scoped=true"
import script from "./ValidationObserver.vue?vue&type=script&lang=js"
export * from "./ValidationObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281b8378",
  null
  
)

export default component.exports